import ConsumableIcon from "@/components/icons/ConsumableIcon";
import ElectricityIcon from "@/components/icons/ElectricityIcon";
import CrossReference from "@/components/links/CrossReference/CrossReference";
import List from "@/components/visualizations/List/List";
import Widget from "@/pages/dashboard/components/Widget/Widget";
import { ProductBy, useProductUsageImpactPerType } from "@/pages/dashboard/hooks/useProductImpact";
import { formatAmountWithUnit } from "@/pages/dashboard/utils/formatters";
import { ImpactMetric } from "@/pages/dashboard/utils/types";

function ProductUsageImpactTopContributing({
  metric,
  productId,
  by,
}: {
  metric: ImpactMetric;
  productId: number;
  by: ProductBy;
}) {
  const { data, isLoading, isFetching } = useProductUsageImpactPerType({
    productId,
    by,
    metric: metric.key,
  });

  const listData =
    data && data.impact_per_type?.length > 0
      ? data.impact_per_type.map((row) => {
          return {
            icon: row.type === "electricity" ? <ElectricityIcon /> : <ConsumableIcon />,
            label: <CrossReference to={`/products/${productId}/usage`}>{row.label}</CrossReference>,
            value: row.impact[metric.key],
            to: `/products/${productId}/usage`,
            extraProp: {
              label: "Amount",
              value: formatAmountWithUnit(row.amount, row.unit, 0),
            },
          };
        })
      : [];

  return (
    <Widget
      title={"The top contributing usage factors"}
      tooltip={
        "The top contributing usage factors that are responsible for your product's total transport footprint."
      }
    >
      <List
        loading={isLoading || isFetching}
        data={{
          list: listData,
          total: data?.total_impact[metric.key],
        }}
        format={metric.formatter}
      />
    </Widget>
  );
}

export default ProductUsageImpactTopContributing;
